import React, { useState, useEffect } from 'react';
import { EnvironmentOutlined, CloseOutlined } from '@ant-design/icons';
import Modal from 'antd/es/modal';
import getCoords, { getBackgroundCoords } from '../utils/getCoords';

const GPSStatusIndicator = () => {
  const [gpsStatus, setGpsStatus] = useState('checking');
  const [showModal, setShowModal] = useState(false);
  const [isDismissed, setIsDismissed] = useState(() => {
    return localStorage.getItem('gpsIndicatorDismissed') === 'true';
  });

  useEffect(() => {
    let isCancelled = false;

    const resolveGpsStatus = async () => {
      try {
        if (navigator.permissions) {
          const permission = await navigator.permissions.query({
            name: 'geolocation',
          });

          if (permission.state === 'denied') {
            if (!isCancelled) setGpsStatus('denied');
            return;
          }

          if (permission.state === 'granted') {
            if (!isCancelled) setGpsStatus('granted');
            return;
          }

          if (permission.state === 'prompt') {
            const cachedCoords = await getBackgroundCoords();
            if (!isCancelled) setGpsStatus(cachedCoords ? 'granted' : 'checking');
            return;
          }
        }

        if (!navigator.geolocation) {
          if (!isCancelled) setGpsStatus('unavailable');
          return;
        }

        const fallbackCoords = await getCoords(false);
        if (fallbackCoords) {
          if (!isCancelled) setGpsStatus('granted');
          return;
        }

        const cachedCoords = await getBackgroundCoords();
        if (!isCancelled) setGpsStatus(cachedCoords ? 'granted' : 'unavailable');
      } catch {
        if (!isCancelled) setGpsStatus('unavailable');
      }
    };

    resolveGpsStatus();

    return () => {
      isCancelled = true;
    };
  }, []);

  const handleDismiss = (e) => {
    e.stopPropagation();
    setIsDismissed(true);
    localStorage.setItem('gpsIndicatorDismissed', 'true');
  };

  const handleClick = (e) => {
    e.stopPropagation();
    setShowModal(true);
  };

  if (gpsStatus !== 'denied' && gpsStatus !== 'unavailable') {
    return null;
  }

  if (isDismissed) {
    return null;
  }

  return (
    <>
      <div
        onClick={handleClick}
        style={{
          position: 'fixed',
          top: '60px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1001,
          backgroundColor: '#8c8c8c',
          padding: '4px 12px',
          borderRadius: '18px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
          cursor: 'pointer',
        }}
      >
        <EnvironmentOutlined style={{ color: '#fff', fontSize: '14px' }} />
        <span style={{ color: '#fff', fontSize: '12px', fontWeight: 500 }}>
          GPS onemogućen
        </span>
        <CloseOutlined
          onClick={handleDismiss}
          style={{
            color: 'rgba(255, 255, 255, 0.8)',
            fontSize: '12px',
            padding: '6px',
            marginLeft: '2px',
            marginRight: '-6px',
            cursor: 'pointer',
          }}
        />
      </div>

      {showModal && (
        <Modal
          title="GPS Lokacija Onemogućena"
          visible={showModal}
          onOk={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
          footer={null}
          closable={true}
          centered
        >
          <div style={{ lineHeight: '1.6' }}>
            <p>
              <strong>Aplikacija radi normalno bez GPS-a</strong>, ali lokacija
              pomaže u tačnijem praćenju narudžbi i posjeta.
            </p>

            <p style={{ marginTop: '16px', marginBottom: '8px' }}>
              <strong>Kako omogućiti GPS:</strong>
            </p>

            <ol style={{ paddingLeft: '20px', margin: 0 }}>
              <li>
                Otvorite <strong>Postavke</strong> vašeg telefona
              </li>
              <li>
                Idite na <strong>Lokacija</strong> (ili{' '}
                <strong>Privatnost</strong> → <strong>Lokacija</strong>)
              </li>
              <li>
                Uključite <strong>Koristi lokaciju</strong>
              </li>
              <li>
                Pronađite <strong>{window.location.hostname}</strong> u listi
                aplikacija
              </li>
              <li>
                Dodijelite dozvolu{' '}
                <strong>"Uvijek" ili "Samo tokom korištenja"</strong>
              </li>
            </ol>

            <p
              style={{ marginTop: '16px', fontSize: '12px', color: '#8c8c8c' }}
            >
              Nakon omogućavanja, osvježite aplikaciju.
            </p>
          </div>
        </Modal>
      )}
    </>
  );
};

export default GPSStatusIndicator;
